import React from 'react';

function RenderHTML({ data }) {
    return (
        <div dangerouslySetInnerHTML={{ __html: data }} />
    );
}

export default RenderHTML;